var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "115px",
    viewBox: "0 0 115 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40633124,3.40633124 C7.11631201,-0.303649532 13.1313793,-0.303649532 16.8413601,3.40633124 L16.8413601,3.40633124 L57.4998457,44.0648457 L98.1586399,3.40633124 C101.868621,-0.303649532 107.883688,-0.303649532 111.593669,3.40633124 C115.30365,7.11631201 115.30365,13.1313793 111.593669,16.8413601 L70.9348457,57.4998457 L111.593669,98.1586399 C115.23365,101.798621 115.302329,107.657525 111.799705,111.381239 L111.593669,111.593669 C107.883688,115.30365 101.868621,115.30365 98.1586399,111.593669 L98.1586399,111.593669 L57.4998457,70.9348457 L16.8413601,111.593669 C13.1313793,115.30365 7.11631201,115.30365 3.40633124,111.593669 C-0.303649532,107.883688 -0.303649532,101.868621 3.40633124,98.1586399 L44.0648457,57.4998457 L3.40633124,16.8413601 C-0.233649895,13.2013789 -0.302328785,7.34247508 3.20029457,3.61876101 Z",
    id: "cross",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f52306058f9664829b9162831d8593ff.svg";
export { ForwardRef as ReactComponent };